import { slideContainer } from "./selectors"
import store from "./player-store"

let zoomIndex = 0
const ZOOM_LEVELS = [1, 1.2, 1.5, 1.75, 2, 2.5, 3, 4]

export const resetZoom = () => {
  store.zoom = 1
  slideContainer.css("transform", "")
}

const setPlayerZoom = () => {
  if (store.zoom > 1) {
    slideContainer.css("transform", `scale(${store.zoom})`)
  } else {
    resetZoom()
  }
}

export const updateZoom = (index) => {
  zoomIndex = index
  const zoom = ZOOM_LEVELS[index]
  store.zoom = zoom
  setPlayerZoom()
}

const zoomIn = () => {
  const newZoomIndex = zoomIndex + 1
  if (newZoomIndex === ZOOM_LEVELS.length) {
    return
  }
  updateZoom(newZoomIndex)
}

const zoomOut = () => {
  if (zoomIndex === 0) {
    return
  }
  const newZoomIndex = zoomIndex - 1
  updateZoom(newZoomIndex)
}

export const initializeZoom = () => {
  store.zoom = 1
  $(".zoom-in").on("click", function (e) {
    e.preventDefault()
    e.stopPropagation()
    zoomIn()
  })

  $(".zoom-out").on("click", function (e) {
    e.preventDefault()
    e.stopPropagation()
    zoomOut()
  })
}
